import { MetricCardType, AnalyticsMetric } from '../../../const';

export const formatDurationValue = (
  seconds: number
): { minutes: number; seconds: number } => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  return { minutes, seconds: remainingSeconds };
};

export const convertValueByType = (value: number, type: string): number => {
  switch (type) {
    case MetricCardType.AVERAGE_RESPONSE_TIME_SECONDS:
      return value / 1000;
    default:
      return value;
  }
};

export const getYAxisTicks = (
  chartType?: AnalyticsMetric | MetricCardType
): number[] | undefined => {
  const isCSATChart = chartType === MetricCardType.CSAT_STARS;

  const isPercentageChart = [
    AnalyticsMetric.SUCCESS_RATE,
    AnalyticsMetric.ERROR_RATE,
    AnalyticsMetric.USER_ABANDONED,
  ].includes(chartType as AnalyticsMetric);

  if (isPercentageChart) {
    return [0, 25, 50, 75, 100];
  }

  if (isCSATChart) {
    return [0, 1, 2, 3, 4, 5];
  }

  return undefined;
};
